import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_relationship_add = _resolveComponent("ontos-relationship-add")!
  const _component_ontos_kanban_board = _resolveComponent("ontos-kanban-board")!
  const _component_ontos_relationship_unlink_dialog = _resolveComponent("ontos-relationship-unlink-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ontos_kanban_board, {
      context: _ctx.childContext,
      workspace: _ctx.workspace,
      filter: _ctx.filter,
      items: _ctx.items,
      "reload-items": _ctx.reloadOwner,
      "initial-values": _ctx.initialValues,
      "link-created": _ctx.linkCreated,
      "add-in-lane": _ctx.editing.link || _ctx.editing.create ? _ctx.openInLane : null,
      "unlink-item": _ctx.editing.unlink ? _ctx.askUnlink : null,
      deletes: false,
      scope: _ctx.scope,
      flush: _ctx.flush,
      "header-to": _ctx.headerTo,
      "known-candidates": _ctx.knownCandidates,
      onCandidates: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('candidates', $event))),
      onOpenInstance: _ctx.openInstance,
      onChanged: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('changed'))),
      onNoDimensions: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('no-dimensions'))),
      onShowMessage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('showMessage', $event))),
      onShowErrorMessage: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
    }, _createSlots({ _: 2 }, [
      (_ctx.$slots.title)
        ? {
            name: "title",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "title", {}, undefined, true)
            ]),
            key: "0"
          }
        : undefined,
      (_ctx.$slots.tabs)
        ? {
            name: "tabs",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "tabs", {}, undefined, true)
            ]),
            key: "1"
          }
        : undefined,
      (_ctx.editable || _ctx.$slots.controls)
        ? {
            name: "controls",
            fn: _withCtx(() => [
              (_openBlock(), _createBlock(_Teleport, {
                to: _ctx.addTo || 'body',
                disabled: !_ctx.addTo,
                defer: ""
              }, [
                (_ctx.editable)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass({'board-add--first': !!_ctx.headerTo})
                    }, [
                      _createVNode(_component_ontos_relationship_add, {
                        ref: "add",
                        "owner-context": _ctx.ownerContext,
                        owner: _ctx.owner,
                        property: _ctx.property,
                        domains: _ctx.domains,
                        "reverse-infos": _ctx.reverseInfo,
                        workspace: _ctx.workspace,
                        "target-read": _ctx.knownCandidates,
                        onAdded: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onAdded($event))),
                        onShowMessage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showMessage', $event))),
                        onShowErrorMessage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('showErrorMessage', $event)))
                      }, null, 8, ["owner-context", "owner", "property", "domains", "reverse-infos", "workspace", "target-read"])
                    ], 2))
                  : _createCommentVNode("", true)
              ], 8, ["to", "disabled"])),
              _renderSlot(_ctx.$slots, "controls", {}, undefined, true)
            ]),
            key: "2"
          }
        : undefined,
      (_ctx.$slots.below)
        ? {
            name: "below",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "below", {}, undefined, true)
            ]),
            key: "3"
          }
        : undefined
    ]), 1032, ["context", "workspace", "filter", "items", "reload-items", "initial-values", "link-created", "add-in-lane", "unlink-item", "scope", "flush", "header-to", "known-candidates", "onOpenInstance"]),
    (_ctx.unlinking)
      ? (_openBlock(), _createBlock(_component_ontos_relationship_unlink_dialog, {
          key: 0,
          "owner-context": _ctx.ownerContext,
          owner: _ctx.owner,
          property: _ctx.property,
          item: _ctx.unlinking,
          workspace: _ctx.workspace,
          onUnlinked: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onUnlinked($event))),
          onClosed: _cache[9] || (_cache[9] = ($event: any) => (_ctx.unlinking = null)),
          onShowMessage: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('showMessage', $event)))
        }, null, 8, ["owner-context", "owner", "property", "item", "workspace"]))
      : _createCommentVNode("", true)
  ], 64))
}